<template lang="pug">
  v-container
    router-view
</template>
<script>
export default {
};
</script>
